import { translate } from '@components/i18n';
import { Distributor } from '@models/distributor';

export const columns = [
    {
        title: translate('columns.client'),
        dataIndex: 'nome',
        sorter: true,
        width: '25%',
        render: (_, record: Distributor.Response): React.ReactNode => {
            const addresses = []

            if (record?.endereco1?.trim()) {
                addresses.push(record.endereco1)
            } else if (record?.endereco2?.trim()) {
                addresses.push(record.endereco2)
            }

            return (
                <>
                    <span
                        style={{
                            display: 'flex',
                            columnGap: '5px',
                            userSelect: 'none',
                            fontWeight: 'bold'
                        }}
                    >
                        {record.nome}
                    </span>
                    <span
                        style={{
                            fontStyle: 'italic',
                            fontSize: '0.850em'
                        }}>
                        {translate("columns.address")}: {addresses.join(" / ")}
                    </span>
                </>
            );
        },
    },
    {
        title: translate('columns.code'),
        dataIndex: 'codigo',
        sorter: true,
        width: '10%',
    },
    {
        title: translate('columns.cia'),
        dataIndex: 'companhia',
        sorter: true,
        width: '10%',
    },
    {
        title: translate('columns.type'),
        dataIndex: 'tipo',
        sorter: true,
        width: '10%',
        render: (_, record: Distributor.Response): React.ReactNode => {
            return (
                <span
                    style={{
                        display: 'flex',
                        columnGap: '5px',
                        userSelect: 'none',
                    }}
                >
                    {record.tipo} - {record.tipoDescricao}
                </span>
            );
        },
    },
    {
        title: translate('columns.city'),
        dataIndex: 'cidade',
        sorter: true,
        width: '15%',
    },
    {
        title: translate('columns.state'),
        dataIndex: 'zona',
        sorter: true,
        width: '10%',
    },
    {
        title: translate('columns.cnpj'),
        dataIndex: 'cnpj',
        sorter: true,
        width: '10%',
    },
];

export const filterTypes = [
    {
        name: 'TODOS',
        description: translate('filters.all'),
    },
    {
        name: 'CNPJ',
        description: translate('filters.cnpj'),
    },
    {
        name: 'NOME',
        description: translate('filters.name'),
    },
    {
        name: 'CODIGO',
        description: translate('filters.clientCode'),
    },
    {
        name: 'CIDADE',
        description: translate('filters.city'),
    },
    {
        name: 'ESTADO',
        description: translate('filters.state'),
    },
    {
        name: 'TIPO',
        description: translate('filters.type'),
    },
];

export const filterTypesOrder = [
    {
        name: 'CNPJ_CLIENTE',
        description: translate('filters.cnpj'),
    },
    {
        name: 'NOME_CLIENTE',
        description: translate('filters.name'),
    },
    {
        name: 'CODIGO_CLIENTE',
        description: translate('filters.clientCode'),
    },
    {
        name: 'CIDADE_CLIENTE',
        description: translate('filters.city'),
    },
    {
        name: 'ZONA_CLIENTE',
        description: translate('filters.state'),
    },
    {
        name: 'TIPO_PEDIDO',
        description: translate('filters.orderType'),
    },
];

export const filterTypesOrderHistory = [
    {
        name: 'CNPJ_CLIENTE',
        description: 'CNPJ',
    },
    {
        name: 'NOME_CLIENTE',
        description: 'Nome',
    },
    {
        name: 'PEDIDO',
        description: 'Pedido',
    },
    {
        name: 'CODIGO_CLIENTE',
        description: 'Código do Cliente',
    },
    {
        name: 'CIDADE_CLIENTE',
        description: 'Cidade',
    },
    {
        name: 'ZONA_CLIENTE',
        description: 'Estado',
    },
    {
        name: 'TIPO_PEDIDO',
        description: 'Tipo de Pedido',
    },
];

export const filterOptions = [
    { value: 'all', label: 'Todos' },
    { value: 'name', label: 'Nome' },
    { value: 'code', label: 'Código' },
];

export const filterOptionsTranspo = [
    { value: 'all', label: translate('filters.all') },
    { value: 'name', label: translate('filters.name') },
    { value: 'codigoTipoTransporte', label: translate('filters.transport') },
];

export const filterModalSelectOptions = [
    { value: 'todos', label: translate('filters.all') },
    { value: 'nome', label: translate('filters.name') },
    { value: 'codigo', label: translate('filters.code') },
];
